<template>
  <div v-if="rendered">
    <base-header class="pb-6 db-header">
      <!-- DESKTOP FILTROS -->
      <b-row aling-v="center" class="pt-4 d-none d-md-flex">
        <b-col xl="6" class="d-flex align-items-center" style="gap: 14px">
          <div class="db-header-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
          </div>
          <div>
            <h1 class="db-header-title">Dashboard</h1>
            <p class="db-header-sub">Resumo de atividade e faturação</p>
          </div>
        </b-col>
        <b-col xl="2">
          <el-select
            v-model="restaurantesSelecionados"
            multiple
            filterable
            placeholder="Restaurantes (Todos)"
            @change="mudarDatas"
          >
            <el-option
              v-for="r in restaurantes"
              :key="r.label"
              :label="r.label"
              :value="r.value"
            />
          </el-select>
        </b-col>
        <b-col xl="2">
          <flat-picker
            v-model="dates.start"
            placeholder="Selecionar data início"
            :config="{ ...datepickerConfig, maxDate: dates.end || null }"
            class="w-100 mb-2 form-control db-date-input"
          />
          <p class="pointer db-link-clear" @click="limparDatas">Limpar datas</p>
        </b-col>
        <b-col xl="2">
          <flat-picker
            v-model="dates.end"
            placeholder="Selecionar data fim"
            :config="{ ...datepickerConfig, minDate: dates.start || null }"
            class="w-100 mb-2 form-control db-date-input"
          />
          <p class="db-link-filter pointer" @click="mudarDatas">Filtrar</p>
        </b-col>
      </b-row>

      <!-- MOBILE FILTROS -->
      <div class="d-md-none px-3 pt-3">
        <button
          class="db-mobile-toggle w-100 d-flex justify-content-between align-items-center"
          @click="filtrosMobileAbertos = !filtrosMobileAbertos"
        >
          <span>Filtrar</span>
          <i
            class="ni"
            :class="filtrosMobileAbertos ? 'ni-bold-up' : 'ni-bold-down'"
          ></i>
        </button>
      </div>
      <div class="mobile-filters px-3 pt-3" v-show="filtrosMobileAbertos">
        <el-select
          v-model="restaurantesSelecionados"
          multiple
          filterable
          placeholder="Restaurantes (Todos)"
          class="w-100 mb-3"
        >
          <el-option
            v-for="r in restaurantes"
            :key="r.label"
            :label="r.label"
            :value="r.value"
          />
        </el-select>
        <flat-picker
          v-model="dates.start"
          placeholder="Data início"
          :config="{ ...datepickerConfig, maxDate: dates.end || null }"
          class="w-100 mb-3 form-control db-date-input"
        />
        <flat-picker
          v-model="dates.end"
          placeholder="Data fim"
          :config="{ ...datepickerConfig, minDate: dates.start || null }"
          class="w-100 mb-3 form-control db-date-input"
        />
        <div class="d-flex justify-content-between pb-3">
          <button class="db-btn-clear" @click="limparDatas">Limpar</button>
          <button
            class="db-btn-apply"
            @click="
              mudarDatas();
              filtrosMobileAbertos = false;
            "
          >
            Aplicar
          </button>
        </div>
      </div>
    </base-header>

    <b-container fluid class="mt--6 content">
      <!-- KPIs -->
      <dashboard-kpis
        :dados="dadosDashboard"
        :media-visitas="mediaVisitasPorCliente"
        :media-visitas-prev="mediaVisitasPorClientePrev"
        @ver-clientes="verClientes"
      />

      <!-- TOP LISTAS -->
      <dashboard-top-listas
        :top-clientes="dadosDashboard.topClientes"
        :top-restaurantes="dadosDashboard.topRestaurantes"
        @ver-perfil="verPerfilCliente"
      />

      <!-- GRÁFICOS -->
      <dashboard-graficos :dados="dadosDashboard" />
    </b-container>
  </div>
  <LoadingOverlay v-else />
</template>

<script>
  import flatPicker from "vue-flatpickr-component";
  import { Portuguese } from "flatpickr/dist/l10n/pt.js";
  import "flatpickr/dist/flatpickr.css";
  import { Select, Option } from "element-ui";
  import Chart from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import LoadingOverlay from "@/components/Loading/LoadingOverlay";
  import { dashboardService } from "@/services";

  import DashboardKpis from "./Dashboardkpis.vue";
  import DashboardTopListas from "./Dashboardtoplistas.vue";
  import DashboardGraficos from "./Dashboardgraficos.vue";

  Chart.plugins.register(ChartDataLabels);

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      LoadingOverlay,
      flatPicker,
      DashboardKpis,
      DashboardTopListas,
      DashboardGraficos,
    },
    computed: {
      mediaVisitasPorCliente() {
        const t = Number(this.dadosDashboard.visitas_total) || 0;
        const c = Number(this.dadosDashboard.clientes_ativos) || 0;
        return c === 0 ? "0.00" : (t / c).toFixed(2);
      },
      mediaVisitasPorClientePrev() {
        const t = Number(this.dadosDashboard.visitas_total_prev) || 0;
        const c = Number(this.dadosDashboard.clientes_ativos_prev) || 0;
        return c === 0 ? "0.00" : (t / c).toFixed(2);
      },
    },
    data() {
      return {
        filtrosMobileAbertos: false,
        restaurantes: [],
        restaurantesSelecionados: [],
        dadosDashboard: {},
        rendered: false,
        dates: { start: "", end: "" },
        datepickerConfig: {
          locale: Portuguese,
          altInput: true,
          allowInput: true,
          altFormat: "d/m/Y",
          dateFormat: "Y-m-d",
        },
      };
    },
    methods: {
      formatDate(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
      },
      verClientes(segmento) {
        this.$router.push({
          path: "/clientes/lista-clientes",
          query: {
            segmento,
            restaurantes: this.restaurantesSelecionados.join(","),
          },
        });
      },
      verPerfilCliente(qrcode) {
        this.$router.push({
          path: "/clientes/lista-clientes",
          query: { cliente: qrcode },
        });
      },
      limparDatas() {
        localStorage.removeItem("dashboardDatas");
        this.dates = { start: "", end: "" };
        this.carregarDados();
      },
      async carregarRestaurantes() {
        const rests = await dashboardService.getRestaurantes();
        this.restaurantes = rests.map((r) => ({
          value: r.nome,
          label: r.nome,
        }));
      },
      async carregarDados() {
        this.rendered = false;

        // datas default: últimos 90 dias
        if (!this.dates.start || !this.dates.end) {
          const today = new Date();
          const past = new Date();
          past.setDate(today.getDate() - 90);
          this.dates.start = this.formatDate(past);
          this.dates.end = this.formatDate(today);
        }

        try {
          this.dadosDashboard = await dashboardService.getResumo(
            this.dates.start,
            this.dates.end,
            this.restaurantesSelecionados,
          );
        } catch (err) {
          console.error("Erro ao carregar dashboard:", err);
        }

        this.rendered = true;
      },
      async mudarDatas() {
        if (!this.dates.start || !this.dates.end) return;
        if (new Date(this.dates.start) > new Date(this.dates.end)) {
          this.dates.start = null;
          this.dates.end = null;
          return;
        }

        localStorage.setItem(
          "dashboardDatas",
          JSON.stringify({
            start: this.dates.start,
            end: this.dates.end,
            restaurantes: this.restaurantesSelecionados,
          }),
        );

        await this.carregarDados();
      },
    },
    async mounted() {
      // restaurar datas guardadas
      const guardado = localStorage.getItem("dashboardDatas");
      if (guardado) {
        const p = JSON.parse(guardado);
        this.dates.start = p.start;
        this.dates.end = p.end;
        this.restaurantesSelecionados = p.restaurantes || [];
      }

      await this.carregarRestaurantes();
      await this.carregarDados();
    },
  };
</script>

<style>
  /* ── HEADER / FILTROS ── */
  .db-header .el-input__inner {
    border: 1.5px solid #e8e4e0 !important;
    border-radius: 9px !important;
    font-size: 13px !important;
    height: 36px !important;
    line-height: 36px !important;
  }
  .db-date-input {
    border: 1.5px solid #e8e4e0 !important;
    border-radius: 9px !important;
    font-size: 13px !important;
    height: 36px !important;
    padding: 0 10px !important;
  }
  .db-date-input:focus {
    border-color: #ff825d !important;
    box-shadow: 0 0 0 3px rgba(255, 130, 93, 0.12) !important;
  }
  .db-link-clear {
    font-size: 13px;
    color: #b0a8a0;
    margin: 0;
    cursor: pointer;
  }
  .db-link-clear:hover {
    color: #e05a3a;
  }
  .db-link-filter {
    font-size: 13px;
    font-weight: 600;
    color: #ff825d;
    margin: 0;
    cursor: pointer;
  }
  .db-link-filter:hover {
    color: #e05a3a;
  }
  .db-mobile-toggle {
    border: 1.5px solid #e8e4e0;
    border-radius: 10px;
    background: #fff;
    padding: 10px 16px;
    font-size: 13.5px;
    color: #5a534f;
    cursor: pointer;
  }
  .db-btn-clear {
    border: none;
    background: none;
    font-size: 13px;
    color: #b0a8a0;
    cursor: pointer;
    padding: 8px 12px;
  }
  .db-btn-apply {
    background: #ff825d;
    color: #fff;
    border: none;
    border-radius: 9px;
    padding: 8px 18px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }
  .db-btn-apply:hover {
    background: #e86b45;
  }

  /* ── TÍTULOS DE SECÇÃO ── */
  .db-section-title {
    font-size: 18px !important;
    font-weight: 800 !important;
    color: #1a1210 !important;
    letter-spacing: -0.3px;
    margin-bottom: 0 !important;
  }

  /* ── KPI CARDS ── */
  .db-kpi-row-wrap {
    margin-bottom: 8px;
  }
  .db-kpi-card {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    padding: 20px 22px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.15s;
  }
  .db-kpi-card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }
  .db-kpi-card--accent {
    background: #fff8f5;
    border-color: #ffe8df;
  }
  .db-kpi-label {
    font-size: 12px !important;
    font-weight: 700 !important;
    color: #b0a8a0 !important;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 6px !important;
  }
  .db-kpi-val {
    font-size: 36px !important;
    font-weight: 800 !important;
    color: #1a1210 !important;
    letter-spacing: -1.5px;
    line-height: 1.1;
    margin-bottom: 4px !important;
  }
  .db-kpi-val--orange {
    color: #ff825d !important;
  }
  .db-kpi-delta {
    font-size: 13px !important;
    font-weight: 600 !important;
    margin: 0 !important;
  }
  .db-kpi-hint {
    font-size: 12px;
    color: #b0a8a0;
    display: block;
    margin-top: 2px;
  }
  .db-kpi-action {
    font-size: 13px;
    font-weight: 600;
    color: #ff825d;
    cursor: pointer;
    margin: 8px 0 0;
    display: inline-block;
  }
  .db-kpi-action:hover {
    color: #e05a3a;
  }

  /* ── DELTA COLOURS ── */
  .positive {
    color: #0a7a4a !important;
    font-size: 13px !important;
  }
  .negative {
    color: #c04820 !important;
    font-size: 13px !important;
  }

  /* ── TOP LISTAS ── */
  .db-list-title {
    font-size: 16px !important;
    font-weight: 800 !important;
    color: #ff825d !important;
    margin: 0 !important;
  }
  .db-list-item {
    transition: background 0.08s;
  }
  .db-list-item:hover {
    background: #fdfcfb;
  }
  .db-list-name {
    font-size: 13.5px !important;
    font-weight: 600 !important;
    color: #1a1210 !important;
    margin-bottom: 4px !important;
  }
  .db-list-pct {
    font-weight: 400;
    color: #ff825d;
    font-size: 12px;
  }
  .db-list-meta {
    font-size: 12px;
    color: #b0a8a0;
  }
  .db-pag-arrow {
    font-size: 20px;
    color: #b0a8a0;
    transition: color 0.12s;
  }
  .db-pag-arrow:hover {
    color: #ff825d;
  }

  /* ── GRÁFICOS ── */
  .db-chart-card {
    border: 1.5px solid #f0ece8 !important;
    border-radius: 14px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 2px 8px rgba(0, 0, 0, 0.04) !important;
    margin-bottom: 16px;
  }
  .db-chart-card .card-header {
    border-bottom: 1px solid #f5f2ef !important;
    background: #fff !important;
    border-radius: 14px 14px 0 0 !important;
    padding: 14px 20px !important;
  }
  .db-chart-title {
    font-size: 15px !important;
    font-weight: 700 !important;
    color: #1a1210 !important;
  }
  .db-toggle-btn {
    padding: 5px 13px;
    border: 1.5px solid #e8e4e0;
    border-radius: 8px;
    background: #fff;
    font-size: 12px;
    font-weight: 600;
    color: #8a857e;
    cursor: pointer;
    margin-left: 6px;
    transition: all 0.12s;
    font-family: inherit;
  }
  .db-toggle-btn.active {
    background: #ff825d;
    border-color: #ff825d;
    color: #fff;
  }
  .db-toggle-btn:hover:not(.active) {
    border-color: #d0c8c0;
    color: #1a1210;
  }

  /* ── MOBILE ── */
  @media (max-width: 768px) {
    .base-header {
      padding-bottom: 0 !important;
    }
    .base-header .row {
      flex-direction: column;
      gap: 12px;
    }
    .base-header .col-xl-2,
    .base-header .col-xl-6 {
      width: 100%;
      max-width: 100%;
    }
    .el-select {
      width: 100% !important;
    }
    .db-section-title {
      font-size: 16px !important;
    }
    .db-kpi-val {
      font-size: 28px !important;
    }
    .positive,
    .negative {
      font-size: 13px !important;
    }
    .row.pb-5 > .col-6 {
      flex: 0 0 100%;
      max-width: 100%;
    }
    .chart canvas {
      max-height: 260px !important;
    }
    .mobile-filters {
      background: #fff;
      border-radius: 14px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
      margin: 16px 0;
      padding: 16px;
    }
  }
  .db-header-icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    background: #ff825d;
    border-radius: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    box-shadow: 0 4px 14px rgba(255, 130, 93, 0.3);
  }
  .db-header-title {
    font-size: 20px !important;
    font-weight: 800 !important;
    color: #1a1210 !important;
    margin: 0 !important;
    letter-spacing: -0.4px;
  }
  .db-header-sub {
    font-size: 13px;
    color: #b0a8a0;
    margin: 2px 0 0 !important;
  }
  @media (max-width: 480px) {
    .db-kpi-val {
      font-size: 24px !important;
    }
  }
</style>
